import { type FormatLocale, numberFormat } from '@/lib/i18n/format'

const COMPACT: Intl.NumberFormatOptions = {
  notation: 'compact',
  maximumFractionDigits: 1,
}

/**
 * Compact display form used anywhere a template remix metric is shown
 * ("1.2K" in English, "1234" in German, "1.2万" in Japanese).
 */
export function formatRemixCount(count: number, locale: FormatLocale): string {
  return numberFormat(locale, COMPACT).format(count)
}
